@if(notificationPermission() === 'denied'){
  <nz-alert
    nzShowIcon
    nzType="warning"
    [nzMessage]="'notification.permission_denied' | translate"
    />
  <nz-divider/>
} @else if (notificationPermission() === 'default') {
  <nz-alert
    nzShowIcon
    nzType="warning"
    [nzMessage]="'notification.permission_default' | translate"
    [nzAction]="actionTemplate1"
    />
  <ng-template #actionTemplate1>
    <button nz-button nzSize="small" nzType="primary" (click)="handleNotificationPermission()">
      {{ 'notification.permission_request' | translate }}
    </button></ng-template
    >

    <nz-divider/>
  }

  <nz-tabset nzTabPosition="left" class="tabs">
    @for (tab of tabs; track tab) {
      <nz-tab [nzTitle]="tab.title" >
        <h4 nz-typography>
          {{tab.title}}
        </h4>
        <nz-divider/>
        <div class="tab-content">
          @if (tab.id === 'bookinghub-notification') {
            <div class="notification-items">
              @for (item of onlineBookings$ | async; track item) {
                <div
                  class="book-item"
                  (click)="handleEventClick(item)"
                  >
                  <div nz-row nzJustify="space-between">
                    <div nz-col nzFlex="auto" class="dates">
                      @if (item.status === 2) {
                        <nz-badge
                          nzStatus="success"
                        ></nz-badge>
                      }
                      @if (item.status === 1) {
                        <nz-badge nzStatus="error"></nz-badge>
                      }
                      {{ item?.bookingDate | date: 'dd/MM/yyyy' }} |
                      {{ item?.startTime }} - {{ item?.endTime }}
                    </div>
                    <div>
                      <nz-tag  class="dates">{{ item?.createdAt | date: 'dd/MM/yyyy HH:mm' }}</nz-tag>
                    </div>
                  </div>
                  <div class="user-employee-info">
                    <div nz-row nzJustify="space-between" class="user">
                      თამანშ.: {{ item?.employee?.user?.fullName }} |
                      {{ item?.employee?.position?.name }}
                    </div>
                    <div nz-row nzJustify="space-between" class="user">
                      მომხ.: {{ item?.user?.fullName }} - {{ item?.user?.mobilePhone }}
                    </div>
                  </div>
                  @if (item.services && item.services.length) {
                    @for (service of item.services; track service) {
                      <div
                        style="margin: 10px 0"
                        class="user"
                        nz-row nzJustify="space-between">
                        <div nz-col nzFlex="1" [style.color]="service?.serviceCategory?.color" >
                          <div>{{ service?.name }}</div>
                          <div class="time">დრო: {{ service?.time }}</div>
                        </div>
                        <div nz-col nzFlex="initial" >
                          {{ service?.price }} ₾
                        </div>
                      </div>
                    }
                  }
                  <div nz-row class="price">
                    <nz-space>
                      <div *nzSpaceItem>ფასი ჯამში:</div>
                      <div *nzSpaceItem [style.color]="'#FF3FB4'" >{{ item?.totalPrice }} ₾</div>
                    </nz-space>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </nz-tab>
    }
  </nz-tabset>
